import Markdown from 'markdown-to-jsx';
import { ErrorBoundary } from 'react-error-boundary';

// Define the props interface, including children
interface MarkdownWrapperProps {
  children: string;
}

const MarkdownWrapper: React.FC<MarkdownWrapperProps> = ({ children }) => {
  try {
    if (children) {
      return (
        <ErrorBoundary fallback={<>{children}</>}>
          <Markdown
            options={{
              overrides: {
                a: {
                  props: {
                    target: '_blank'
                  }
                },
                ul: {
                  props: {
                    style: { margin: '0.5em' }
                  }
                },
                ol: {
                  props: {
                    style: { margin: '0.5em' }
                  }
                },
                li: {
                  props: {
                    style: { marginLeft: '1em' }
                  }
                }
              }
            }}>
            {children}
          </Markdown>
        </ErrorBoundary>
      );
    } else {
      return <>{children}</>;
    }
  } catch {
    return children;
  }
};

export default MarkdownWrapper;
